import { SAnimatedPhoto } from './AnimatedPhoto.styled'
import { Image } from 'components/Image'
import { SelectedMemory } from 'components/memory/MemoryUtils'
import { AutoPlayer } from 'components/videoPlayer/autoPlayer/AutoPlayer'
import { ReactNode } from 'react'

export function UserAnimatedPhoto(props: {
  memory?: SelectedMemory
  isPublic?: boolean
  hideOriginalImage?: boolean
  muted?: boolean
  borderRadius?: number
  customPlaceholder?: ReactNode
  noPlaceholderAbsolutePosition?: boolean
}) {
  return (
    <SAnimatedPhoto borderRadius={props.borderRadius}>
      <AutoPlayer
        isAuth={!props.isPublic}
        containerCss={{ display: 'flex', justifyContent: 'center' }}
        src={props?.memory?.selectedAnimation?.file?.url}
        muted={props.muted}
        customPlaceholder={props.customPlaceholder}
        noPlaceholderAbsolutePosition={props.noPlaceholderAbsolutePosition}
      />
      {!props.hideOriginalImage && <Image src={props.memory?.original_file?.url} />}
    </SAnimatedPhoto>
  )
}
